import React from 'react';

import type { ImmutableEntity } from '@uncinc/react-drupal-core/types';
import DefaultProfileTeaser from './Teaser';

import DefaultProfilePage from './Page';
import type { ProfileDefault } from '../../../types/uncinc_profile/profile';

interface DefaultProfileProps {
  entity: ImmutableEntity<ProfileDefault>;
  viewMode: string;
  classes: string;
}

const NodeProfileWrapper: React.FC<DefaultProfileProps> = ({ entity, viewMode, classes = '' }) => {
  if (viewMode === 'teaser') {
    return <DefaultProfileTeaser entity={entity} classes={classes} />;
  }

  return <DefaultProfilePage entity={entity} />;
};

export default NodeProfileWrapper;
